import { I18nComponente } from "@/types/gerais"

export const TTipoDeAtividadesi18n: I18nComponente = {
  "pt-BR": {
    criarTipoDeAtividade: "criar tipo de atividade",
  },
  "es-CO": {
    criarTipoDeAtividade: "añadir tipo de actividad",
  }
}
